export default __webpack_public_path__ + "static/MasterCard-93b8c196f6398396be3eca130c7889de.png";